import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { DEFAULT_TESTIMONIAL_PROMPT, TESTIMONIAL_PROMPT_MAX } from '../../../shared/testimonial';

export function TestimonialPrompts() {
  const [clients, setClients] = useState<Array<{ id: string; name: string; testimonial_prompt: string | null }>>([]);
  const [clientId, setClientId] = useState('');
  const [prompt, setPrompt] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    api<{ clients: typeof clients }>('/api/admin/automations/testimonial-prompts')
      .then((data) => setClients(data.clients))
      .catch((error) => setMessage(error instanceof Error ? error.message : 'Could not load testimonial prompts.'));
  }, []);
  const save = async () => {
    setBusy(true);
    setMessage('');
    try {
      const data = await api<{ testimonial_prompt: string | null }>(`/api/admin/automations/testimonial-prompts/${encodeURIComponent(clientId)}`,
        { method: 'PUT', json: { prompt } });
      setClients((current) => current.map((client) => client.id === clientId ? { ...client, testimonial_prompt: data.testimonial_prompt } : client));
      setMessage('Prompt saved. It will appear in the next recording link.');
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Could not save the prompt.');
    } finally { setBusy(false); }
  };
  return <section className="atm-card" style={{ marginTop: 18 }}>
    <div className="atm-title">Testimonial question</div>
    <p className="atm-desc">Choose the question each client sees when recording. Leave it blank to use the default.</p>
    <label className="field-label" htmlFor="testimonial-client">Client</label>
    <select id="testimonial-client" value={clientId} disabled={busy} onChange={(event) => {
      setClientId(event.target.value);
      setPrompt(clients.find((client) => client.id === event.target.value)?.testimonial_prompt ?? '');
      setMessage('');
    }} style={{ width: '100%', marginBottom: 12 }}>
      <option value="">Select a client</option>
      {clients.map((client) => <option key={client.id} value={client.id}>{client.name}</option>)}
    </select>
    {clientId && <>
      <label className="field-label" htmlFor="testimonial-question">Question</label>
      <textarea id="testimonial-question" value={prompt} maxLength={TESTIMONIAL_PROMPT_MAX} disabled={busy}
        placeholder={DEFAULT_TESTIMONIAL_PROMPT} onChange={(event) => setPrompt(event.target.value)} rows={3} style={{ width: '100%' }} />
      <p className="empty-note">Default: {DEFAULT_TESTIMONIAL_PROMPT}</p>
      <button type="button" className="btn" disabled={busy} onClick={() => { void save(); }}>{busy ? 'Saving…' : 'Save question'}</button>
    </>}
    {message && <p role="status" className="empty-note">{message}</p>}
  </section>;
}

